import React, {ReactElement} from 'react';
type ListItemProps = {
  classes: string;
  openTnCModal: () => void;
};

const OtpTnC: React.FC<ListItemProps> = (
  props: ListItemProps,
): ReactElement => {
  const {classes, openTnCModal} = props;

  return (
    <div className={`${classes} `}>
      <span className="text-red-600 font-roboto" onClick={openTnCModal}>
        <b>T&C apply</b>
      </span>
    </div>
  );
};
export default OtpTnC;
